// Default / LOCAL environment — `nx serve` on localhost:4201. Identity is the
// local k3d Keycloak (`echospaces` realm). Replaced by a per-env file at build time.
export const environment = {
  // Where this build is served from. `development` config (deploy.mjs local)
  // ships this file → k3d. `nx serve`/`serve-host` use the `cli` config →
  // environment.cli.ts. Surfaced by the corner env badge.
  source: 'local',
  production: false,
  domain: 'echospaces.localtest.me',
  // Local k3d Keycloak — the same issuer the BFF validates JWTs against.
  // Company-rooted host (echospaces is always in the apex); HTTPS via the
  // self-signed local CA (trust-local-ca.sh).
  keycloakUrl: 'https://identity.echospaces.localtest.me',
  realm: 'echospaces',
  clientId: 'portal-client',
  // `apiUrl` is relative (`/api`): the dev-server proxy (proxy.conf.cjs →
  // tools/proxy/spa-proxy.cjs) forwards `/api` to a local es-world-api if
  // one is up, else to the k3d-deployed BFF. It injects X-Tenant-Slug
  // (default `echospaces`) to stand in for the tenant subdomain.
  apiUrl: '/api',
};
